import {TableSettings} from "../../../../tableSettings";

export const salesTaxReturnList:TableSettings = {
tableVersion: 1007,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: 'S', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    // { accessor:'void', Header: 'V', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'postDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'branch', Header: 'BR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'refNo', Header: 'Ref. #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'entity', Header: 'Entity', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'accountType', Header: 'Account Type', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'currency', Header: 'CUR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amount', Header: 'Amount', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'paidAmount', Header: 'Balance', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'balance', Header: 'Balance', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Create by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const salesCostBatchRecogList:TableSettings = {
  tableVersion: 1001,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};
